import { useFormattedAsapTime } from '@/features/pos/components/OrderFinalization/parts/FormFields/parts/PhoneModeFields/parts/DeliveryTimeSelector/hooks/formats/useFormattedAsapTime'
import {
    Time,
    Timed,
} from '@/features/pos/components/OrderFinalization/parts/FormFields/parts/PhoneModeFields/parts/DeliveryTimeSelector/types'
import { formatTimedTime } from '@/features/pos/components/OrderFinalization/parts/FormFields/parts/PhoneModeFields/parts/DeliveryTimeSelector/utils/formats'

export const useFormattedTime = (time: Time | null): string => {
    const asapTime = time && 'asap' in time ? time.asap : undefined

    const formattedAsapTime = useFormattedAsapTime(asapTime)

    if (!time) return ''

    return asapTime ? formattedAsapTime : formatTimedTime((time as { timed: Timed }).timed)
}
